export default __webpack_public_path__ + "static/media/ProfileImg.adaf2723.jpg";